import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import api from '../api';

import Context from './context';

const CompanyTypesProvider = (props) => {
    const { children } = props;
    const [data, setData] = useState([]);
    const [error, setError] = useState({});
    const get = useCallback(
        (query) =>
            api
                .get(query)
                .then((res) => {
                    setData(res);
                    return res;
                })
                .catch(setError),
        []
    );

    const post = useCallback((body) => api.post(body).catch(setError), []);

    const put = useCallback((body) => api.put(body).catch(setError), []);
    return (
        <Context.Provider
            value={{
                get,
                post,
                put,
                data,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

CompanyTypesProvider.propTypes = {
    children: PropTypes.element.isRequired
};

export default CompanyTypesProvider;
